import {
  ProjectStatus,
  SurveyState,
  Wave
} from '../../../data/gql-gen/dashboard/graphql'
import { surveysByCreation } from '../MultiMarket/markets.utils'

/** The dashboard derives a wave's status from its markets: Draft until one leaves draft. */
export const hasLaunched = (wave: Pick<Wave, 'status'>): boolean =>
  wave.status !== ProjectStatus.Draft

/** The wave's oldest fielding market, the one its Per Market results open on. */
export const firstFieldingMarketId = (wave: Wave): string | undefined =>
  surveysByCreation(wave.surveys).find(
    (survey) => survey.state !== SurveyState.Draft
  )?.surveyId
